<div class="overlay__panel__wrapper">
	<div class="cart__wrapper">
		<ul class="cart__list">
			<li class="cart__feedback" *ngIf="!products?.length">
				<span class="w-9 text-center">Seu carrinho está vazio.</span>
			</li>

			<ng-container *ngIf="products?.length">
				<li *ngFor="let item of products; trackBy: trackByProduct">
					<div class="cart__item">
						<div
							class="cart__item__wrapper"
							routerLink="/product/{{
								item.product.parentId || item.productId
							}}"
							[queryParams]="{
								variation: item.product.parentId ? item.product.id : null
							}"
						>
							<img
								*ngIf="
									item.product.pictures[0] as mainPicture;
									else defaultImage
								"
								class="cart__item__image"
								[src]="mainPicture.url"
								[alt]="mainPicture.description"
								[style.object-fit]="objectFit"
							/>
							<ng-template #defaultImage>
								<div class="cart__img__default">
									<app-img-default></app-img-default>
								</div>
							</ng-template>

							<div class="cart__item__content">
								<div class="cart__item__info">
									<small class="cart__item__brand">
										{{ item.product.brand }}
									</small>
									<strong class="cart__item__name">
										{{ item.product.name }}
									</strong>
									<small class="cart__item__code">
										SKU: {{ item.product.sku }}
									</small>
								</div>
								<strong class="cart__item__price">
									{{ item.unitPrice | currency: 'R$' }}
									{{ item.product.sellingUnit }}
								</strong>
								<div
									*appProductAvailability="{
										product: item.product
									}"
								></div>
							</div>
						</div>

						<p-divider
							class="cart__item__divider"
							layout="vertical"
						></p-divider>

						<div class="cart__item__actions">
							<app-counter
								*appProductAvailability="{
									product: item.product,
									type: 'counter'
								}"
								size="sm"
								[cart]="true"
								[value]="item.quantity"
								[step]="item.product.saleMultiplier"
								[product]="item.product"
								[disabled]="cartFacade.requesting"
								(changeEvent)="getQtd($event, item.product, item.unitPrice)"
							></app-counter>

							<p-button
								class="button__w__full"
								styleClass="p-button-outlined p-button-sm p-button-danger"
								label="Remover"
								(onClick)="removeProduct(item.productId)"
							></p-button>
						</div>
					</div>

					<p-divider></p-divider>
				</li>
			</ng-container>
		</ul>
	</div>

	<p-button
		*ngIf="products?.length"
		class="button__w__full button__cart"
		label="Ver carrinho"
		(onClick)="openCart()"
	></p-button>
</div>
